export default "__VITE_ASSET__C679uUgo__"